<template>
    <div>
        <base-header type="gradient-primary" class="pb-3 pt-5 pt-md-8">

        </base-header>

        <div class="container-fluid mt--7">
            <div class="row mt-5 mb-3">
                <div class="col-12 mb-5 mb-xl-0">


                    <div class="row">
                        <div class="col-12 col-sm-4 mb-3" v-for="(value,key) in stat" :key="key">

                            <card class="card-stats">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <i class="fas fa-2x "
                                           v-bind:class="getIcon(key)"
                                        ></i>
                                    </div>
                                    <div class="col">
                                        <h5 class="card-title text-uppercase text-muted mb-0">{{key}}</h5>
                                    </div>

                                    <div class="col-auto">
                                        <span class="h2 font-weight-bold mb-0">{{value | numberFormat}}</span>
                                    </div>
                                </div>
                            </card>

                        </div>
                    </div>


                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col col-sm-auto">
                                    <base-input class="input-group-alternative"
                                                placeholder="Search"
                                                addon-left-icon="fas fa-search"
                                                v-model="form.q" @input="search(form)">
                                    </base-input>
                                </div>

                                <div class="col col-sm-auto">
                                    <select class="form-control " v-model="form.name" @input="search(form)">
                                        <option value="">
                                            -- ผลิตภัณฑ์ทั้งหมด --
                                        </option>

                                        <option v-for="(data,index) in nameList" :value="data.name" :key="index">
                                            {{data.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-auto col-sm text-right">
                                    <base-button type="primary" @click="generate">
                                        <i class="fas fa-plus-circle"></i> Generate Code
                                    </base-button>
                                </div>
                            </div>
                        </div>


                        <div class="table-responsive">
                            <v-table class="table"
                                     :data="list"
                                     :currentPage.sync="currentPage"
                                     :pageSize="pageSize"
                                     @totalPagesChanged="totalPages = $event"
                            >
                                <thead slot="head">
                                <v-th sortKey="code">Code</v-th>
                                <v-th sortKey="code">Product</v-th>
                                <v-th class="text-center" sortKey="code">verified</v-th>
                                <v-th sortKey="create_date">Create date</v-th>
                                <v-th sortKey="update_date">Update date</v-th>
                                </thead>
                                <tbody slot="body" slot-scope="{displayData}">
                                <tr v-for="row in displayData" :key="row.id">
                                    <td>
                                        {{row.code}}
                                    </td>

                                    <td>
                                        {{row.name}}
                                    </td>

                                    <td class="text-center">
                                        <i class="fas fa-2x "
                                           v-bind:class="{
                                           'text-success': row.used === '1', 'text-danger': row.used !== '1',
                                           'fa-check-circle': row.used === '1', 'fa-times-circle': row.used !== '1'
                                           }"></i>
                                    </td>

                                    <td>
                                        {{row.create_date}}
                                    </td>

                                    <td>
                                        {{row.update_date ? row.update_date : '-'}}
                                    </td>
                                </tr>
                                </tbody>
                            </v-table>
                        </div>

                        <div class="card-body">
                            <div class="row justify-content-end">
                                <div class="col-auto">
                                    <smart-pagination
                                            :currentPage.sync="currentPage"
                                            :totalPages="totalPages"
                                            :maxPageLinks="3"
                                    />
                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        </div>

    </div>
</template>
<script>

    import {
        GET_CODE, GET_CODE_STAT, GET_NAME_LIST, SEARCH_CODE
    } from "../../store/actions.type";
    import store from '../../store';
    import {mapState} from 'vuex';
    import * as _ from 'underscore'

    export default {
        computed: {
            ...mapState({
                list: state => state.code.list,
                stat: state => state.code.stat,
                nameList: state => state.code.nameList,
            }),
        },
        async created() {
            store.dispatch(GET_CODE);
            store.dispatch(GET_NAME_LIST);
            store.dispatch(GET_CODE_STAT, this.form);
        },

        data() {
            return {
                form: {q: null, name: ""},
                data: [],
                filters: {
                    name: {value: '', keys: ['code', 'name']}
                },
                currentPage: 1,
                totalPages: 0,
                pageSize: 10
            };
        },
        methods: {
            search: _.debounce((data) => {
                store.dispatch(SEARCH_CODE, data);
                store.dispatch(GET_CODE_STAT, data);
            }, 1000).bind(this),
            getIcon(key) {
                let icon = null;
                if (key === 'used') {
                    icon = '    fa-check-circle text-success';
                } else if (key === 'unused') {
                    icon = 'fa-times-circle text-danger';
                } else {
                    icon = 'fa-barcode';
                }

                return {
                    [icon]: true
                }
            },
            generate() {
                this.$router.push('/code/generate')
            }
        }

    }
    ;
</script>
<style scoped lang="scss">
    .table td {
        white-space: normal;
        vertical-align: middle;
    }
</style>
